export type ParsedSection = { number: string; title: string; body: string };

export type ParsedLegalDoc = {
  title: string;
  effectiveDate: string;
  intro: string[];
  sections: ParsedSection[];
};

export function parseLegalDoc(raw: string): ParsedLegalDoc {
  const trimmed = raw.trim();
  const sectionChunks = trimmed.split(/\n(?=\d+\.\s+)/);

  const introBlock = sectionChunks[0] ?? '';
  const introLines = introBlock.split(/\n\n/).map((s) => s.trim()).filter(Boolean);
  const title = introLines[0] ?? '';
  const effectiveLine = introLines[1] ?? '';
  const effectiveDate = effectiveLine.startsWith('Effective Date:')
    ? effectiveLine
    : introLines[1] ?? '';
  const intro = introLines.slice(2);

  const sections: ParsedSection[] = [];
  for (let i = 1; i < sectionChunks.length; i++) {
    const chunk = sectionChunks[i]!;
    const firstNewline = chunk.indexOf('\n');
    const firstLine = firstNewline >= 0 ? chunk.slice(0, firstNewline) : chunk;
    const body = firstNewline >= 0 ? chunk.slice(firstNewline + 1).trim() : '';
    const match = firstLine.match(/^(\d+)\.\s+(.+)$/);
    if (match) {
      sections.push({ number: match[1]!, title: match[2]!.trim(), body });
    }
  }

  return { title, effectiveDate, intro, sections };
}
